import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Intake from "@/pages/Intake";
import OnSite from "@/pages/OnSite";
import TrackJob from "@/pages/TrackJob";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminBoard from "@/pages/AdminBoard";
import AdminJob from "@/pages/AdminJob";

function RequireAuth({ children }) {
  const token = localStorage.getItem("ch_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/onsite" element={<OnSite />} />
        <Route path="/track" element={<TrackJob />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAuth><AdminBoard /></RequireAuth>} />
        <Route path="/admin/jobs/:id" element={<RequireAuth><AdminJob /></RequireAuth>} />
      </Routes>
    </BrowserRouter>
  );
}
